export enum RoleConst {
    AdminRole = 'ADMIN',
    AdminUnitRole = 'ADMINUNIT',
    OperatorRole = 'OPERATOR',
    OperatorUnitRole = 'OPERATORUNIT',
    ApplicantRole = 'APPLICANT',
}
